<template>
    <div v-if="machine.dragging.value" class="pb2-capture" />
</template>

<script setup lang="ts">
import { useDragMachine } from '@src/Common/Builder/useDragMachine';

// Transparent layer above the iframe while dragging — without it the
// iframe document swallows pointer events and the parent machine stalls.
const machine = useDragMachine();
</script>

<style scoped>
.pb2-capture {
    position: absolute;
    inset: 0;
    z-index: 20;
    cursor: grabbing;
    touch-action: none;
}
</style>
